import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthPageComponent } from './pages/auth-page/auth-page.component';
import { AuthForgotPasswordPageComponent } from './pages/auth-forgot-password-page/auth-forgot-password-page.component';
import { AuthResetPasswordPageComponent } from './pages/auth-reset-password-page/auth-reset-password-page.component';
import { AuthAccountActivationComponent } from './pages/auth-account-activation/auth-account-activation.component';
import { AuthRegisterPageComponent } from './pages/auth-register-page/auth-register-page.component';
import { AuthPageProviderComponent } from './pages/auth-page-provider/auth-page-provider.component';

const routes: Routes = [
  {
    path: '',
    component: AuthPageComponent
  },
  {
    path: 'forgot-password',
    component: AuthForgotPasswordPageComponent
  },
  {
    path: 'reset-password/:email/:token',
    component: AuthResetPasswordPageComponent
  },
  {
    path: 'account-activation/:token',
    component: AuthAccountActivationComponent
  },
  {
    path: 'provider-register',
    component: AuthRegisterPageComponent
  },
  {
    path: 'login',
    component: AuthPageComponent
  },
  {
  path: 'provider',
  component: AuthPageProviderComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
